var insertResults = require('./insert-results');

module.exports = function (apiEndpoint) {
    var $container = $('.event-landing__cta-container');

    if ($container.length) {
        var $cta = $container.find('.event-landing__cta');

        $cta.click(function () {
            insertResults(apiEndpoint);
        });
    }
};